function CombineTechStackComponent({
  logo1,
  name1,
  name2,
  name3,
  name4,
  name5,
}: any) {
  return (
    <div className="bg-gray-3 flex flex-row px-4 w-[100px] h-[100px] md:w-[640px] md:h-[120px] items-center justify-around rounded">
      <div className=" rounded-md  flex flex-col items-center justify-center">
        <div className="w-[35px] md:w-[70px] overflow-hidden rounded mb-3">
          <img
            src={logo1}
            alt="thumbnail"
            className="object-cover w-full h-full"
          />
        </div>
        <p className="font-medium text-[12px]">{name1}</p>
      </div>

      <div className="flex flex-col font-medium text-[12px]">
        <p className="mb-4">- {name2}</p>
        <p className="">- {name3}</p>
      </div>

      <div className="flex flex-col font-medium text-[12px]">
        <p className=" mb-4">- {name4}</p>
        <p className="">- {name5}</p>
      </div>
    </div>
  );
}

export default CombineTechStackComponent;
